import React from 'react';
import './TabIndexesInfluence.less';

function IndexTable(props, i) {
  return (
    <tr key={i}>
      <td>
        <span className="kpi-num">{props.num}</span>
        <span className="kpi-name">{props.name}</span>
      </td>
      <td className="kpi-role">{props.role}</td>
    </tr>
  );
}

const headers = [
  { title: 'Целевые показатели эффективности (базовая часть гранта)', fundingId: 1 },
  { title: 'Целевые показатели эффективности реализации программы (специальная часть гранта)', fundingId: 2 },
];

export default function TabIndexesInfluence(props) {
  const { kpis } = props.data;
  return (
    <div className="tab-indexes-influence">
      {headers.map((header, i) => (
        <article key={i}>
          <h4>{header.title}</h4>
          <div className="table table-striped">
            <table>
              <tbody>
                {kpis.map((kpi, index) => kpi.fundingId === header.fundingId && <IndexTable key={index} num={kpi.num} name={kpi.name} role={kpi.role} />)}
              </tbody>
            </table>
          </div>
        </article>
      ))}
    </div>
  );
}
